// extracted by mini-css-extract-plugin
module.exports = {"bnai1ta":"bnai1ta","wy08boc":"wy08boc","l17oigga":"l17oigga","l1fjnvw0":"l1fjnvw0","t1yrjahc":"t1yrjahc"};